<template>
    <div class="xcard">
        <p class="orange--text">
            <b>Primero busque el posgrado ya existente, en caso de no existir puede crearlo</b>
        </p>
        <input v-model.trim="nombre" type="text" class="form-control" placeholder="Buscar por nombre en la base de datos..." />
        <button class="btn btn-sm btn-link" @click="get_posgrados()">
            <span class="glyphicon glyphicon-search"></span> buscar
        </button>

        <v-data-table
            :headers="headers"
            :items="posgrados"
            :loading="loading"  
            v-model="selected"
            :single-select="true"
            show-select
            dense
            disable-pagination 
            hide-default-footer
            :items-per-page="50"
            class="elevation-0">
    
            <template v-slot:[`item.ind`]="a">
                <span> {{ a.index + 1 }} </span>
            </template>
            <template v-slot:[`item.proyecto_fecha_aprobacion`]="{item}">
                <span> {{ parseFecha(item.proyecto_fecha_aprobacion) }} </span>
            </template>
            <template v-slot:[`item.fecha_inicio`]="{item}">
                <span> {{ parseFecha(item.fecha_inicio) }} </span>
            </template>
            <template v-slot:[`item.fecha_fin`]="{item}">
                <span> {{ parseFecha(item.fecha_fin) }} </span>
            </template>
            <template v-slot:[`item.opt`]="{item}"> 
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="orange" dark v-bind="attrs" v-on="on" @click="crearPosgrado(item)" outlined small >
                            <v-icon>mdi-folder-plus</v-icon>
                        </v-btn>
                    </template>
                    <span>Crear posgrado</span>
                </v-tooltip> 
            </template>

        </v-data-table> 

        <div class="text-center">
            <v-btn color="green" :disabled="loading || selected.length==0" class="mt-2" outlined @click="vincular()"> Vincular Seleccionado </v-btn>
        </div>
    </div>
</template>
  
<script>
import gql from 'graphql-tag';
import { query } from './utils';

  

export default {
    components: {},
    props:{
        showvolver:{type:Boolean, default: true},
    },
    data() {
        return { 
            posgrados: [],
            loading: false,
            nombre: '',
            selected: [],
            headers: [
                { text: '#', value: 'ind' },
                { text: 'nombre', value: 'nombre' },
            ]
        };
    },
    watch: { },
    methods: {
        async get_posgrados(){
            const un = this.$store.state.CARGO.sede.unidad_negocio
            const s = query(un, this.nombre) 
            const sql = gql`${s}`;
            this.posgrados = []
            this.loading = true;
            const r = await this.$apollo.query({ query: sql }).then(({ data: { getPostgrados } }) => getPostgrados);
            // window.console.log('posgradossss', r); 
            if(r){
                this.posgrados = r;
            }
            this.loading = false;
        }, 
        vincular(){
            const p = this.selected[0]
            this.loading = true
            this.$emit('select', p.id, p.nombre)
            setTimeout(()=>{
                this.loading = false
            },4000)
        }
    },
    mounted() { 
        this.get_posgrados();
    },
};
</script>
  